import React from "react";

export default function SeeMore({ isOpen }) {
  return (
    <div className="tel-pt-see-more" role="button">
      <div
        className={isOpen ? "tel-pt-see-more__button tel-pt-see-more__button__open" : "tel-pt-see-more__button"}
        type="button"
      ></div>
    </div>
  );
}
